import React from 'react';
import useMoveLogic from '../../model/hooks/useMoveLogic';
import { clamp } from 'lodash';
import { animated } from 'react-spring';

export default function AreaWrapper({ children }) {
  const { xFunc, yFunc, handlers, offsetData, animatedDrag, bounding } = useMoveLogic();

  const offsetX = bounding.width / 2;
  const offsetY = bounding.height / 2;

  const formattedBounding = {
    width: `${bounding.width}px`,
    height: `${bounding.height}px`,
    x: xFunc.to((x) => `${clamp(x - offsetX, bounding.x?.min - offsetX, bounding.x?.max - offsetX)}px`),
    y: yFunc.to((y) => `${clamp(y - offsetY, bounding.y?.min - offsetY, bounding.y?.max - offsetY)}px`),
  };

  const moveStyles = Object.entries(formattedBounding).reduce((acc, [key, value]) => {
    acc[`--${key}`] = value;
    return acc;
  }, {});

  return (
    <animated.div className={'interactive-shop__area'} style={moveStyles} {...handlers()}>
      {children(bounding, animatedDrag, offsetData, moveStyles)}
    </animated.div>
  );
}
